import React, {Component} from 'react';
import {connect} from 'react-redux';
import {path} from 'ramda';
import {push} from 'react-router-redux';
import Table from '../../сomponents/Table';
import Breadcrumbs from '../../common/Breadcrumbs';
import ConfirmAction from '../../common/ConfirmAction';
import {changeModalState} from '../../actions/modal';
import {deleteObject} from '../../actions/objectToDelete';
import {fetchRoles, removeRoleById} from '../../api/roles';
import './style.css';
import Preloader from "../../common/Preloader";


export class People extends Component {

  constructor(props) {
    super(props);
    this.onSearch = this.onSearch.bind(this);
    this.onChangeItemsPerPage = this.onChangeItemsPerPage.bind(this);
    this.handlerDelete = this.handlerDelete.bind(this);
    this.handlerEdit = this.handlerEdit.bind(this);
    this.addRole = this.addRole.bind(this);
    this.onChangeCurrentPage = this.onChangeCurrentPage.bind(this);
    this.textInput = null;
    this.myRef = element => {
      this.textInput = element;
    };
    this.state = {
      items: Array.from([]),
      container: false,
      search: '',
      itemsPerPage: 10,
      loading: true,
      currentPage: 0,
    };

    this.columns = [
      'id',
      'role',
      'countOfUsers'
    ];

    this.columnNames = [
      'Id',
      'Role',
      'Count of Users',
    ];
  }

  addRole() {
    this.props.addNewRole();
  }

  onSearch(e) {
    e.preventDefault();
    this.setState({
      search: e.target.value,
    });
    return false;
  }

  onChangeCurrentPage(currentPage) {
    this.setState({
      currentPage: currentPage,
    });
  }

  onChangeItemsPerPage(e) {
    e.preventDefault();
    this.setState({
      itemsPerPage: e.target.value,
    });
    return false;
  }

  componentDidUpdate() {
    const {loading} = this.state;
    const itemList = path(['roles', 'list'], this.props);
    if (loading && itemList) {
      this.setState({loading: false});
    }
  }

  componentWillMount() {
    this.props.list();
  }

  handlerDelete(id) {
    this.props.handleObjectToDelete({
      id: parseInt(id),
      handler: removeRoleById,
    });

    this.props.handleModalState({
      isOpen: !this.props.modal.isOpen,
      modalId: 'remove_role',
    });
  }

  handlerEdit(id) {
    this.props.moveToEdit(id);
  }

  render() {
    const itemList = path(['roles', 'list'], this.props);
    const {loading} = this.state;
    const itemActions = {
      edit: {
        handler: this.handlerEdit,
        icon: ['fa fa-circle-thin icon-stack-3x', 'fa fa-pencil icon-stack-1x'],
        iconClass: '',
        context: this,
        hasWrapper: true,
        title: 'edit',
      },
      delete: {
        handler: this.handlerDelete,
        icon: ['fa fa-circle-thin icon-stack-3x', 'fa fa-times icon-stack-1x'],
        permission: {'permAreaKey': 'roles', 'permTypeKey': 'delete'},
        iconClass: '',
        context: this,
        hasWrapper: true,
        title: 'delete',
      }
    };

    const mainPart = loading ? <Preloader show={true} type='circle'/> :
      <Table
        roles={true}
        items={itemList}
        columns={this.columns}
        columnNames={this.columnNames}
        itemsPerPage={this.state.itemsPerPage}
        search={this.state.search}
        actions={itemActions}
        currentPage={this.state.currentPage}
        onChangeCurrentPage={this.onChangeCurrentPage}
        onSearch={this.onSearch}
        onChangeItemsPerPage={this.onChangeItemsPerPage}
      />;

    return (
      <div style={{paddingBottom: '25px'}}>
        <Breadcrumbs list={[
          {url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard'},
          {icon: 'people', name: 'Roles'},
        ]}/>
        <div className="card rounded">
          <div className="card-header rounded-top">
            People
          </div>
          <div className="card-block">
            <div className="clearfix mb-3">
              <button className="btn btn-rounded btn-icon ui-btn pull-right" onClick={this.addRole}>
                <i className="material-icons">add_circle_outline</i>
                <span className="color-default">Add</span>
              </button>

            </div>

            {mainPart}
            <ConfirmAction id={'remove_role'}/>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    list: () => {
      fetchRoles()(dispatch)
    },
    moveToEdit: (id) => {
      dispatch(push('/pages/role-edit/' + id));
    },
    moveToDelete: () => {
      dispatch(push('/pages/job-cards-delete'));
    },
    addNewRole: () => {
      dispatch(push('/pages/role-add'));
    },
    handleModalState: (data) => {
      dispatch(changeModalState(data));
    },
    handleObjectToDelete: (data) => {
      dispatch(deleteObject(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(People);



// WEBPACK FOOTER //
// ./src/containers/Roles/index.js